import { LinearProgressClassKey } from '@material-ui/core/LinearProgress';

const MuiLinearProgress = (): Partial<Record<LinearProgressClassKey, unknown>> => ({
    /* Styles applied to the root element. */
    root: {
        height: 4,
        borderRadius: 4,
    },
    /* Styles applied to the layered bar1 and bar2 elements. */
    bar: {
        borderRadius: 4,
    },
});

export default MuiLinearProgress;
